export const businessConfig = {
  defaultCurrency: 'MXN',
  defaultLocale: 'es-MX',
  taxLabel: 'IVA',
  units: ['pieza', 'kg', 'g', 'litro', 'ml', 'servicio'],
  paymentMethods: ['Efectivo', 'Transferencia', 'Tarjeta', 'Crédito'],
  roles: ['Propietario', 'Administrador', 'Supervisor', 'Cajero', 'Inventario', 'Solo lectura'],
  demoMode: true,
} as const;
